export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      paddingTop: 24, 
      paddingBottom: 10, 
    },
  },
};

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      paddingTop: '6px !important', //needs important here as sibling css with MuiDialogTitle overrides this theme otherwise. A Pain. Maybe fixed by MUI in future???
      paddingBottom: 6,
    },
  },
};

export const MuiDialogActions = {
  styleOverrides: {
    root: {
      paddingLeft: 24,  // 24px left padding
      paddingRight: 24, // 24px right padding
      paddingBottom: 18, // 24px right padding
      marginTop: 2,
    },
  },
};

export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: 12,
    },
  },
};